module.exports = __webpack_public_path__ + "footer-logo-cc2e1356.png";